import { __exports as r } from "../../../../../../../_virtual/index2.js";
import { __require as a } from "./html/sanitizer.js";
import { __require as o } from "./url/sanitizer.js";
var i;
function m() {
  return i ? r : (i = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "sanitizeHtml", {
      enumerable: !0,
      get: function() {
        return t.sanitizeHtml;
      }
    }), Object.defineProperty(e, "sanitizeUrl", {
      enumerable: !0,
      get: function() {
        return n.sanitizeUrl;
      }
    });
    var t = a(), n = o();
  })(r), r);
}
export {
  m as __require
};
